import nes_logo from './resources/logo_nes.png'
import certificate from './resources/certificate.png'
import del_logo from './resources/del.png'
import siemens_logo from './resources/Icon_AutomationDrives.png'
import './App.css';
import './styles/home.css'
import './styles/catalog.css'
import './styles/article_page.css'
import './styles/footer.css'
import { Route, Routes, Link, useNavigate } from 'react-router-dom';
import { Home, extractLink } from './views/front/home'
import Admin from './views/admin/admin'
import News from './views/front/news'
import MainMenu from './menus/main_menu'
import FooterMenu from './menus/footer_menu'
import ArticlePage from './views/front/article_page';
import { useEffect, useState, useContext, useRef } from 'react'
import { useLocation } from 'react-router';
import { LanguageContext } from './utils/lang_provider';
import { fetchData } from './utils/fetch';
import { ContentPage } from './views/front/content_page';
import ScrollToTop from './utils/scroll_to_top'
import Partners from './views/front/partners';
import { Dropdown, Space, Flex, Divider, ConfigProvider } from 'antd';
import { DownOutlined, FacebookOutlined, LinkedinOutlined, YoutubeOutlined } from '@ant-design/icons';
import { Contact } from './views/front/contact';
import EmptyPage from './views/empty_page'
import Trainings from './views/front/trainings';
import ProtectedRoute from './views/admin/protected_route';
import Login from './templates/login';
import CatalogArticles from './views/front/catalog_articles';

const items = [
  {
    label: 'SK',
    key: 'sk',
  },
  {
    label: 'EN',
    key: "en"
  }
];

function App() {
  const additionalContentRef = useRef(null);
  const navigate = useNavigate();
  const scrollToAdditional = () => {
    navigate("/", { state: { scrollTo: "additional" } });
  };

  const [isMenuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => { setMenuOpen(!isMenuOpen) };
  const [ catalogMenu, setCatalogMenu ] = useState([]);
  const [ webObjects, setWebObjects ] = useState([]);
  const { language, setLanguage } = useContext(LanguageContext);
  const [ itemPages, setItemPages ] = useState([]);
  const [ footerTop, setFooterTop ] = useState([]);
  const [ footerInfo, setFooterInfo ] = useState([]);
  const [ articleItems, setArticleItems ] = useState([]);
  const [ sliders, setSliders ] = useState([]);
  const location = useLocation();

  useEffect(() => {
    async function loadCatalogMenu() {
        try {
            const data = await fetchData(`front/menu/menu-items/product_cat`, language);
            setCatalogMenu(data);
        } catch (error) {
            console.error('Error loading catalog menu:', error);
        }
    }
    async function loadWebObjects() {
        try {
            const data = await fetchData(`front/web-objects/front_page`, language)
            setWebObjects(data);
        } catch (error) {
            console.error('Error loading catalog menu:', error);
        }
    }
    async function loadItemPages() {
      try {
        const result = await fetchData("front/pages/main_menu", language);
        setItemPages(result);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    }
    async function loadFooterTop() {
      try {
        const result = await fetchData("front/web-objects/footer_top", language);
        setFooterTop(result);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    }
    async function loadFooterInfo() {
      try {
        const result = await fetchData("front/web-objects/footer_info", language);
        setFooterInfo(result);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    }
    async function loadArticles() {
      try {
        const response = await fetchData(`front/article/list`, language);
        setArticleItems(response);
        console.log(response);
      } catch (error) {
        console.error('Error loading articles:', error);
      }
    }

    async function loadSliders() {
      try {
        const response = await fetchData(`front/slider/list`, language);
        setSliders(response);
      } catch (error) {
        console.error('Error loading articles:', error);
      }
    }

    loadItemPages();
    loadCatalogMenu();
    loadWebObjects();
    loadFooterTop();
    loadFooterInfo();
    loadArticles();
    loadSliders();
  }, [language]);

  const isHome = location.pathname === "/" || location.pathname === "";

  return (
    <div>
      <ScrollToTop/>
      <Routes>
        <Route path="/login" element={<Login></Login>}></Route>
        <Route path="/admin/*" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
        <Route path="/*" element={
          <div className="Root">
            <div className={`App ${isHome ? "" : "no-video"}`}>
              <Header language={language} catalogMenu={catalogMenu} setLanguage={setLanguage} toggleMenu={toggleMenu} scrollToAdditional={scrollToAdditional}/>
              <Body 
                sliders={sliders}
                catalogMenu={catalogMenu} 
                language={language} 
                itemPages={itemPages} 
                webObjects={webObjects}
                articleItems={articleItems}
                additionalContentRef={additionalContentRef}
              />
              <Footer footerInfo={footerInfo} footerTop={footerTop} language={language} />
            </div>
          </div>
        } />
      </Routes>
    </div>
  );
}

function Header({ language, catalogMenu, setLanguage, toggleMenu, scrollToAdditional }) {
  return (
        <header className="App-header">
          <link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet'/>
          <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"/>
          <Flex style={{padding: "10px"}}justify='space-between' gap={20}>
              <Link to="/" style={{ display: "inline-block", transform: "scale(0.7)", transformOrigin: "left"}}>
                <img style={{ width: "auto", display: "block" }} src={nes_logo} alt="NES"/>
              </Link>
            <div className="header-right">
              <Dropdown
                className='language'
                menu={{
                  items: items.map(item => ({
                    ...item,
                    onClick: () => setLanguage(item.key),
                  })),
                }}
                trigger={['click']}
              >
                  <Space>
                    {language.toUpperCase()}
                    <DownOutlined></DownOutlined>
                  </Space>
              </Dropdown>
            </div>
          </Flex>
          <MainMenu catalogMenu={catalogMenu} toggleMenu={toggleMenu} scrollToExtraContent={scrollToAdditional}/>
        </header>
  );
}

function Body({ additionalContentRef, sliders, catalogMenu, language, itemPages, webObjects, articleItems }) {
  return (
    <ConfigProvider 
      theme={{
      token: {
          colorSplit: "rgba(255,255,255,0.2)"
      },
    }}>
      <main className="App-body">
        <Routes>
          <Route key="novinky" path="/novinky" element={<News items={articleItems}/>} />
          <Route key="news" path="/news" element={<News items={articleItems}/>} />
          <Route key="kontakt" path="/kontakt" element={<Contact/>} />
          <Route key="contact" path="/contact" element={<Contact/>} />
          <Route key="skolenia" path="/skolenia" element={<Trainings link={"skolenia"}/>}></Route>
          <Route key="trainings" path="/trainings" element={<Trainings link={"trainings"}/>}></Route>
          {itemPages.map(item => (
            <Route key={item.link} path={"/" + item.link} element={<ContentPage pageLink={item.link} type={item.entityType}/>} />
          ))};
          <Route key="root" path="/" element={<Home catalogMenu={catalogMenu} language={language} articleItems={articleItems} additionalContentRef={additionalContentRef}/>} />
          {webObjects.map(item => {
            const link = extractLink(item.content)
            return (
              <Route key={link} path={link} element={<ContentPage pageLink={link.slice(1)} type="page"/>} />
            )
          })}
          {catalogMenu.map(item => (
            <Route key={item.link} path={`/${item.link}/*`} element={<CatalogArticles type={item.link}/>}></Route>
          ))}
          {articleItems.map(item => (
              <Route key={item.url} path={"/" + item.url} element={<ArticlePage type="article" sliders={sliders} link={item.url}/>}></Route>
          ))}
          <Route key="empty_page" path="/*" element={<EmptyPage></EmptyPage>}></Route>
        </Routes>
      </main>
    </ConfigProvider>
  );
}

function Footer({footerInfo, language}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);
  const linkStyle = {textDecoration: "none", margin: "5px"};

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 800);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="certificate">
            <h3>{language === 'sk' ? "Certifikát kvality" : "Certificate of Quality"}</h3>
            <img alt="" src={certificate}></img>
          </div>
          <div className="del">
            <h3>{language === 'sk' ? "Člen skupiny" : "Member of Group"}</h3>
            <Link to={"https://www.del.cz/"}>
              <img alt="" src={del_logo}></img>
            </Link>
          </div>
          <div className="siemens">
            <h3>Partner</h3>
            <Link to={"https://www.siemens.com/sk/sk.html"}>
              <img alt="" src={siemens_logo}></img>
            </Link>
          </div>
        </div>
        <Divider/>
        <Partners/>
        <Divider></Divider>
        <Flex gap={20} style={{padding: "50px 0 30px 0"}} align="center" justify="space-around" vertical={isMobile}>
          <Flex justify='center' align='center' vertical>
            <Link to="/" style={{ display: "inline-block", transform: "scale(0.7)" }}>
              <img style={{ width: "auto", display: "block" }} src={nes_logo} alt="NES"/>
            </Link>
            <Flex style={{scale: "2"}}>
              <Link style={linkStyle} to="https://www.facebook.com/nesnovadubnica"><FacebookOutlined style={{color: "rgb(237, 28, 36)"}}/></Link>
              <Link style={linkStyle} to="https://www.linkedin.com/company/nes-nová-dubnica-s-r-o-"><LinkedinOutlined style={{color: "rgb(237, 28, 36)"}}/></Link>
              <Link style={linkStyle} to="https://www.youtube.com/channel/UCvddbYplGZXZwP_21fxVtSA"><YoutubeOutlined style={{color: "rgb(237, 28, 36)"}}/></Link>
            </Flex>
          </Flex>
            {footerInfo.map(item => (
              <div dangerouslySetInnerHTML={{"__html": item.content}}></div>
            ))}
          <Divider type={isMobile ? 'horizontal' : 'vertical'}/>
          <div style={{display: "flex", flexDirection: isMobile ? "row" : "column"}}>
            <FooterMenu/>
          </div>
        </Flex>
        <Divider/>
        <Flex justify='center' style={{marginTop: "30px", paddingBottom: "30px"}}>
            © 2025 NES Nová Dubnica s.r.o. All rights reserved.
        </Flex>
      </div>
    </div>
  )
}

export default App;
